
class Accordion
{
  constructor(accordions)
  {
    accordions.forEach(accordion => {
      accordion.addEventListener('click', () => {

        const $this = event.target.closest('.accordion');

        accordions.forEach(elem => {
          if (elem != $this) {
            elem.classList.remove('active');
          }
        });

        if ($this.classList.contains('active')) {
          $this.classList.remove('active');
        } else {
          $this.classList.add('active');
        }
      });
    });
  }
}

export default Accordion;
